module.exports = __webpack_public_path__ + "img/profile-logged-in.fff532fd.jpg";